const initialState = {
  fetching: false,
  fetched: false,
  budgetData: [],
  resultCount: 0,
  error: null,
  organization: null
};

export const budgetTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_BUDGET_TREE_VIEWER": {
      return initialState;
    }
    case "OPEN_BUDGET_TREE_VIEWER": {
      return { ...state, error: null, ...action.viewer };
    }
    case "INIT_BUDGET_TREE": {
      return {
        ...state,
        fetching: false,
        fetched: false,
        budgetData: [],
        error: null
      };
    }
    case "FETCH_BUDGET_TREE_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_BUDGET_TREE_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        budgetData: data,
        resultCount: data["count"],
        organization: action.payload.organization
      };
    }
    case "UPDATED_BUDGET_BY_ROLE_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null
      };
    }
    case "FETCH_BUDGET_TREE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        budgetData: [],
        error
      };
    }
    case "UPDATED_BUDGET_BY_ROLE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialQuickSettingState = {
  isModalVisible: false,
  client: {
    id: null,
    name: null
  },
  year: null,
  suggestionFrom: null,
  fetching: false,
  fetched: false,
  budget: {
    id: null,
    hourlyBudget: null,
    economicBudget: null,
    managerId: null,
    managerName: null,
    squad: {
      squadId: null,
      squadName: null
    },
    cluster: {
      clusterId: null,
      clusterName: null
    },
    businessUnit: {
      businessUnitId: null,
      businessUnitName: null
    },
    loading: false,
    subs: [
      {
        value: null,
        zone: "Belgique",
        managerId: null,
        managerName: null
      },
      {
        value: null,
        zone: "Maroc",
        managerId: null,
        managerName: null
      }
    ]
  },
  suggestions: null,
  error: null,
  organization: null
};

export const quickBudgetSettingReducer = (
  state = initialQuickSettingState,
  action
) => {
  switch (action.type) {
    case "INIT_QUICK_BUDGET_CLIENT": {
      return {
        ...state,
        ...initialQuickSettingState
      };
    }
    case "SET_QUICK_BUDGET_CLIENT": {
      return {
        ...state,
        client: { ...state.client, id: action.item.clientId },
        year: action.item.year,
        suggestionFrom: action.item.suggestionFrom
      };
    }
    case "FETCH_QUICK_BUDGET_CLIENT_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_QUICK_BUDGET_CLIENT_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        budget: data.budget,
        client: data.client,
        suggestions: data.suggestions,
        year: data.year,
        suggestionFrom: data.suggestionFrom,
        isModalVisible: true
      };
    }
    case "SAVE_QUICK_BUDGET_PENDING": {
      return { ...state, budget: { ...state.budget, loading: true } };
    }
    case "SAVE_QUICK_BUDGET_FULFILLED": {
      return { ...state, budget: { ...state.budget, loading: false } };
    }
    case "SAVE_QUICK_BUDGET_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        error,
        budget: { ...state.budget, loading: false }
      };
    }
    default:
      return state;
  }
};

const initialSettingState = {
  fetching: false,
  fetched: false,
  budgetData: null,
  client: null,
  collaborators: {
    fetching: false,
    fetched: false,
    items: []
  },
  error: null,
  organization: null,
  periodSetting: {
    squad: {
      squadId: null,
      squadName: null
    },
    cluster: {
      clusterId: null,
      clusterName: null
    },
    businessUnit: {
      businessUnitId: null,
      businessUnitName: null
    }
  },
  budgetStates: {
    fetching: false,
    fetched: false,
    error: null,
    items: []
  }
};

export const budgetSettingReducer = (state = initialSettingState, action) => {
  switch (action.type) {
    case "INIT_BUDGET_SETTING": {
      return initialSettingState;
    }
    case "SET_BUDGET_SETTING_CLIENT": {
      return {
        ...state,
        client: action.item
      };
    }
    case "FETCH_BUDGET_COLLABORATORS_PENDING": {
      let collaborators = {
        ...state.collaborators,
        fetched: false,
        fetching: true
      };
      return { ...state, collaborators };
    }
    case "FETCH_BUDGET_COLLABORATORS_FULFILLED": {
      const collaborators = {
        ...state.collaborators,
        items: action.payload,
        fetched: true,
        fetching: false
      };
      return {
        ...state,
        collaborators
      };
    }
    case "FETCH_BUDGET_COLLABORATORS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case "SET_BUDGET_PERIODE_SETTING": {
      return {
        ...state,
        periodSetting: action.data
      };
    }

    case "FETCH_BUDGET_CLIENT_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_BUDGET_CLIENT_FULFILLED": {
      let data = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        budgetData: data,
        periodSetting: data.periodSetting,
        organization: action.payload.organization
      };
    }
    case "FETCH_BUDGET_CLIENT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "UPDATE_BUDGET_CLIENT_PENDING": {
      return { ...state };
    }
    case "UPDATE_BUDGET_CLIENT_FULFILLED": {
      return { ...state };
    }
    case "UPDATE_BUDGET_CLIENT_REJECTED": {
      return { ...state };
    }
    case "CLONE_BUDGET_CLIENT_PENDING": {
      return { ...state };
    }
    case "CLONE_BUDGET_CLIENT_FULFILLED": {
      return { ...state };
    }
    case "CLONE_BUDGET_CLIENT_REJECTED": {
      return { ...state };
    }
    case "SET_BUDGET_DATA": {
      return { ...state, budgetData: action.payload };
    }
    case "SET_COLLABORATORS": {
      return {
        ...state,
        collaborators: { ...state.collaborators, items: action.payload }
      };
    }

    case "GET_BUDGET_STATES_COUNT_PENDING": {
      return {
        ...state,
        budgetStates: { ...state.budgetStates, fetching: true, fetched: false }
      };
    }
    case "GET_BUDGET_STATES_COUNT_FULFILLED": {
      return {
        ...state,
        budgetStates: {
          ...state.budgetStates,
          fetching: false,
          fetched: true,
          items: action.payload
        }
      };
    }
    case "GET_BUDGET_STATES_COUNT_REJECTED": {
      return {
        ...state,
        budgetStates: { items: [], fetching: false, fetched: false, error: {} }
      };
    }
    default:
      return state;
  }
};

const initialBudgetSearchWordState = {
  searchWord: ""
};
export const budgetSearchWordReducer = (
  state = initialBudgetSearchWordState,
  action
) => {
  switch (action.type) {
    case "SET_BUDGET_TREE_SEARCH_WORD": {
      return {
        ...state,
        searchWord: action.searchWord
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/budget.js